module.exports = __webpack_public_path__ + "img/PS.3c893b30.svg";